import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { DateTime } from 'luxon';

import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { Fields, defaultValues, prepareInput } from 'app/src/elements/hookForms';
import MutationErrors from 'app/src/elements/MutationErrors';

import { VOID_TXN } from './queries';

export const FIELDS = {
  bankDate: {
    label: 'Void Date',
    type: 'date',
    rules: { required: true },
  },
  memo: {},
};

const VoidTxn = ({ txn, setShowModal, refetch }) => {
  const [formStatus, setFormStatus] = useState();
  const [mutationErrors, setMutationErrors] = useState();

  const {
    control, handleSubmit, formState: { errors }
  } = useForm({
    defaultValues: defaultValues({
      fields: FIELDS,
      resource: { id: txn.id, bankDate: DateTime.now().toISODate() },
    })
  });

  const [voidTxn] = useMutation(VOID_TXN, {
    onCompleted: data => {
      if (data.voidTxn.errors?.length) {
        setFormStatus(null);
        setMutationErrors(data.voidTxn.errors);
      } else {
        refetch();
        setShowModal(false);
      }
    }
  });

  const onSubmit = useCallback(input => {
    setFormStatus('submitting');
    voidTxn({ variables: prepareInput(input, FIELDS) });
  });

  return (
    <View>
      <Fields
        fields={FIELDS}
        control={control}
        errors={errors}
      />

      <MutationErrors errors={mutationErrors} />

      <ButtonGroup>
        <Button label="Create Transaction" onPress={handleSubmit(onSubmit)} />
      </ButtonGroup>
    </View>
  );
};

export default VoidTxn;
